import Vue from "vue";
import Vuex from 'vuex';

Vue.use(Vuex);
//
// export const store = Vue.observable({
//     count: 0,
//     isLoggedInState: false,
//     userInfoState: null,
//     singleNewsModalContentState:null,
//     fontSizeState:100,
// });
export const store = new Vuex.Store({
    state: {

        userInfoState: null,
        showLayout: true,
        showModalIdle: false,
        fontSize: '100%',
        modalFontSize: '100%'

    },
    mutations: {
        setUserInfoMutation(state, data) {
            state.userInfoState = data;
        },
        resetUserInfoMutation(state) {
            state.userInfoState = null;
        },
        setShowLayoutMutation(state, data) {
            state.showLayout = data;
        },
        setShowModalIdleMutation(state, data) {
            state.showModalIdle = data;
        },
        setFontSizeMutation(state, data) {
            state.fontSize = data;
        },
        setModalFontSizeMutation(state, data) {
            state.modalFontSize = data;
        },
    },
    actions: {
        setUserInfo({commit}, event) {
            commit('setUserInfoMutation', event);
        },
        resetUserInfo({commit}) {
            commit('setUserInfoMutation');
        },
        setShowLayout({commit}, event) {
            commit('setShowLayoutMutation', event);
        },
        setShowModalIdle({commit}, event) {
            commit('setShowModalIdleMutation', event);
        },
        setFontSize({commit}, event) {
            commit('setFontSizeMutation', event);
        },
        setModalFontSize({commit}, event) {
            commit('setModalFontSizeMutation', event);
        },
    },

    getters: {},
});
// export const stete = {
//
//     testState: 'test',
// };
// export const mutations = {};
